import React, { FC, useState, useEffect } from 'react';

type ToastList = {
  id: number;
  title: string;
  description: string;
  backgroundColor: string;
  icon: string;
};

const Toast: FC<{
  toastList: ToastList[];
  position: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}> = ({ toastList, position }) => {
  const [list, setList] = useState(toastList);

  useEffect(() => {
    setList(toastList);
  }, [toastList, list]);

  const deleteToast = (id: number) => {
    const index = list.findIndex(e => e.id === id);
    list.splice(index, 1);
    setList([...list]);
  };

  return (
    <>
      <div className={`notification-container ${position}`}>
        {list.map((toast, i) => (
          <div
            // eslint-disable-next-line
            key={i}
            className={`notification toast ${position}`}
            style={{ backgroundColor: `${toast.backgroundColor}` }}
          >
            <button type="button" onClick={() => deleteToast(toast.id)}>
              X
            </button>
            <div className="notification-image">
              <img src={toast.icon} alt="" />
            </div>
            <div>
              <p className="notification-title">{toast.title}</p>
              <p className="notification-message">{toast.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Toast;
